import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export interface GamificationMember {
  community_member_id: number;
  current_level: number;
  current_level_name: string;
  level_progress: number;
  points_to_next_level: number;
  total_points: number;
}

export interface UseGamificationMemberProps {
  enabled?: boolean;
  member_ids?: (number | string)[];
}

export const useGamificationMember = ({
  member_ids,
  enabled = true,
}: UseGamificationMemberProps) =>
  useQuery<GamificationMember[]>(
    ["gamificationMember", member_ids],
    () =>
      reactQueryGet(
        internalApi.gamification.members({
          params: { member_ids },
        }),
      ),
    {
      cacheTime: 60 * 1000,
      enabled,
    },
  );
